"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectImageOptimizationSetting = selectImageOptimizationSetting;

var _ActionTypes = require("./ActionTypes");

function selectImageOptimizationSetting(imageOptimizationSetting) {
  return {
    type: _ActionTypes.SELECT_IMAGE_OPTIMIZATION_SETTING,
    imageOptimizationSetting: imageOptimizationSetting
  };
}